import { AnyType } from '@thehubz/shared/model';

export interface Populate {
  path: string;
  model: string;
  select?: AnyType;
  populate?: Populate;
}

export interface FilterOptions {
  /**
   * Optional access control keys used to scope the query results by permissions or roles.
   */
  accessKeys?: string[];
  /**
   * Projection map specifying fields to include (1) or exclude (0) from the result documents.
   * Example: { password: 0, name: 1 }
   */
  projection?: Record<string, number>;
  /**
   * Array of populate instructions to resolve referenced documents.
   */
  populate?: Populate[];
  /**
   * Whether to return plain JavaScript objects instead of Mongoose documents (lean queries).
   */
  lean?: boolean;
}

export interface FilterAllOptions extends FilterOptions {
  /**
   * Maximum number of items to return.
   */
  limit?: number;
  /**
   * Number of items to skip (offset) for pagination.
   */
  skip?: number;
  /**
   * Optional full-text search string applied to the query.
   */
  search?: string;
  /**
   * Key-value map of filters to apply to the query. Values are flexible and typed as AnyType.
   */
  filters: Record<string, AnyType>;
  /**
   * Sort ordering map where field keys map to 1 (asc) or -1 (desc).
   */
  sort?: Record<string, number>;
  /**
   * Optional metadata representing which filters are currently selected by the consumer (useful for UI state).
   */
  selectedFilterData?: Record<string, AnyType>;
  /**
   * The exact searched text after any normalization or processing (kept for debugging or response metadata).
   */
  searchedText?: string;
}
